export default "__VITE_ASSET__DY81PO1Z__"